import { inject, NgModule } from '@angular/core';
import { RedirectFunction, Routes, RouterModule, Route } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { canActivateGuard } from './common/helpers/modalGuard';
import { GlobalService } from './common/services/global.service';
 
const loadLoginComponent = () => import('./company/login/login.component').then(({ LoginComponent }) => LoginComponent);
const loadLorComponent = () => import('./leaderboard/lor/lor.component').then(({ LorComponent }) => LorComponent);
const loadChronoComponent = () => import('./leaderboard/chrono/chrono.component').then(({ ChronoComponent }) => ChronoComponent);
const loadSignupComponent = () => import('./company/signup/signup.component').then(({ SignupComponent }) => SignupComponent);
const loadVerificationComponent = () => import('./company/verification/verification.component').then(({ VerificationComponent }) => VerificationComponent);
const loadResetpasswordComponent = () => import('./company/resetpassword/resetpassword.component').then(({ ResetpasswordComponent }) => ResetpasswordComponent);
const loadSupportComponent = () => import('./company/support/support.component').then(({ SupportComponent }) => SupportComponent);
const loadSettingsComponent = () => import('./profile/settings/settings.component').then(({ SettingsComponent }) => SettingsComponent);
const loadGeneralIdLayoutComponent = () => import('./company/general-id-layout/general-id-layout.component').then(({ GeneralIdLayoutComponent }) => GeneralIdLayoutComponent);
const loadHomeComponent = () => import('./home/welcome/home.component').then(({ HomeComponent }) => HomeComponent);
const loadTermOfUseComponent = () => import('./company/term-of-use/term-of-use.component').then(({ TermOfUseComponent }) => TermOfUseComponent);
const loadPrivacyPolicyComponent = () => import('./company/privacy-policy/privacy-policy.component').then(({ PrivacyPolicyComponent }) => PrivacyPolicyComponent);
const loadMetaLorComponent = () => import('./meta/meta-lor/meta-lor.component').then(({ MetaLorComponent }) => MetaLorComponent);
const loadDeckLorComponent = () => import('./decks/deck-lor/deck-lor.component').then(({ DeckLorComponent }) => DeckLorComponent);
const loadProfileLorComponent = () => import('./profile/profile-lor/profile-lor.component').then(({ ProfileLorComponent }) => ProfileLorComponent);
const loadChipLorComponent = () => import('./others/chip-lor/chip-lor.component').then(({ ChipLorComponent }) => ChipLorComponent);
const loadSpoilerLorComponent = () => import('./cards/spoiler-lor/spoiler-lor.component').then(({ SpoilerLorComponent }) => SpoilerLorComponent);
const loadContactLorComponent = () => import('./company/contact-lor/contact-lor.component').then(({ ContactLorComponent }) => ContactLorComponent);
const loadDeckLorInfoComponent = () => import('./decks/deck-lor-info/deck-lor-info.component').then(({ DeckLorInfoComponent }) => DeckLorInfoComponent);
const loadStatsLorComponent = () => import('./stats/stats-lor/stats-lor.component').then(({ StatsLorComponent }) => StatsLorComponent);
const loadDeckBuilderLorComponent = () => import('./cards/deck-builder-lor/deck-builder-lor.component').then(({ DeckBuilderLorComponent }) => DeckBuilderLorComponent);
const loadCardsComponent = () => import('./cards/cards/cards.component').then(({ CardsComponent }) => CardsComponent);
const loadOauthRsoComponent = () => import('./company/oauth-rso/oauth-rso.component').then(({ OauthRsoComponent }) => OauthRsoComponent);
const loadLoginAppComponent = () => import('./company/login-app/login-app.component').then(({ LoginAppComponent }) => LoginAppComponent);
const loadTokenAppComponent = () => import('./company/token-app/token-app.component').then(({ TokenAppComponent }) => TokenAppComponent);
const loadGeneralAppComponent = () => import('./company/general-app/general-app.component').then(({ GeneralAppComponent }) => GeneralAppComponent);
const loadLoginAppSuccessComponent = () => import('./company/login-app-success/login-app-success.component').then(({ LoginAppSuccessComponent }) => LoginAppSuccessComponent);
const loadDeckProfileComponent = () => import('./publications/deck-profile/deck-profile.component').then(({ DeckProfileComponent }) => DeckProfileComponent);
const loadPlusGetComponent = () => import('./plus/plus-get/plus-get.component').then(({ PlusGetComponent }) => PlusGetComponent);
const loadHomeAppsComponent = () => import('./home/home-apps/home-apps.component').then(({ HomeAppsComponent }) => HomeAppsComponent);
const loadSubscriberAgreementComponent = () => import('./company/subscriber-agreement/subscriber-agreement.component').then(({ SubscriberAgreementComponent }) => SubscriberAgreementComponent);
const loadAppGetUrlComponent = () => import('./others/app-get-url/app-get-url.component').then(({ AppGetUrlComponent }) => AppGetUrlComponent);
const loadCreatorsComponent = () => import('./company/creators/creators.component').then(({ CreatorsComponent }) => CreatorsComponent);
const loadDecksTournamentInfoLorComponent = () => import('./decks/decks-tournament-info-lor/decks-tournament-info-lor.component').then(({ DecksTournamentInfoLorComponent }) => DecksTournamentInfoLorComponent);
const loadTrendingComponent = () => import('./trending/trending/trending.component').then(({ TrendingComponent }) => TrendingComponent);
const loadDiscordComponent = () => import('./others/discord/discord.component').then(({ DiscordComponent }) => DiscordComponent);
const loadGeneralSidenavComponent = () => import('./general/general-sidenav/general-sidenav.component').then(({ GeneralSidenavComponent }) => GeneralSidenavComponent);
const loadDeckBotComponent = () => import('./decks/deck-bot/deck-bot.component').then(({ DeckBotComponent }) => DeckBotComponent);
const loadTrackerComponent = () => import('./others/tracker/tracker.component').then(({ TrackerComponent }) => TrackerComponent);
const loadTftComponent = () => import('./leaderboard/tft/tft.component').then(({ TftComponent }) => TftComponent);
const loadMetaTftComponent = () => import('./meta/meta-tft/meta-tft.component').then(({ MetaTftComponent }) => MetaTftComponent);
const loadCompTftComponent = () => import('./comps/comp-tft/comp-tft.component').then(({ CompTftComponent }) => CompTftComponent);
const loadCompsBuilderTftComponent = () => import('./comps/comps-builder-tft/comps-builder-tft.component').then(({ CompsBuilderTftComponent }) => CompsBuilderTftComponent);
const loadCompTftInfoComponent = () => import('./comps/comp-tft-info/comp-tft-info.component').then(({ CompTftInfoComponent }) => CompTftInfoComponent);
const loadNewSetComponent = () => import('./comps/new-set/new-set.component').then(({ NewSetComponent }) => NewSetComponent);
const loadWorldsDecksComponent = () => import('./decks/worlds-decks/worlds-decks.component').then(({ WorldsDecksComponent }) => WorldsDecksComponent);
const loadAdventureDataComponent = () => import('./cards/adventure-data/adventure-data.component').then(({ AdventureDataComponent }) => AdventureDataComponent);
const loadAdventureArtifactComponent = () => import('./cards/adventure-artifact/adventure-artifact.component').then(({ AdventureArtifactComponent }) => AdventureArtifactComponent);
const loadChampionsXkoComponent = () => import('./2xko/champions-xko/champions-xko.component').then(({ ChampionsXkoComponent }) => ChampionsXkoComponent);

const redirectToSelectedGame: RedirectFunction = () => {
  const game = inject(GlobalService).getGame();

  switch (game) {
    case 'tft':
      return 'tft/meta';
    case 'riftbound':
      return 'riftbound/new-cards';
    case 'lor':
    case '2xko':
    case 'chrono':
      return `${game}/home`;
    default:
      return 'welcome';
  }
};

export const routes: Routes = [
  {
    path: 'tft',
    pathMatch: 'full',
    redirectTo: 'tft/home',
  },
  {
    path: 'lor',
    pathMatch: 'full',
    redirectTo: 'lor/home'
  },
  {
    path: '2xko',
    pathMatch: 'full',
    redirectTo: '2xko/home',
  },
  {
    path: 'riftbound',
    pathMatch: 'full',
    redirectTo: 'riftbound/home',
  },
  {
    path: 'chrono',
    pathMatch: 'full',
    redirectTo: 'chrono/home',
  },
  {
    path: 'home',
    pathMatch: 'full',
    redirectTo: redirectToSelectedGame,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: redirectToSelectedGame,
  },
  {
    path: '',
    loadComponent: loadGeneralSidenavComponent,
    children: [
      {
        path: 'terms-of-service',
        loadComponent: loadTermOfUseComponent,
        canActivate: [canActivateGuard],
      },
      {
        path: 'privacy-policy',
        loadComponent: loadPrivacyPolicyComponent,
        canActivate: [canActivateGuard],
      },
      {
        path: 'creators',
        loadComponent: loadCreatorsComponent,
        canActivate: [canActivateGuard],
      },
      {
        path: 'subscriber-agreement',
        loadComponent: loadSubscriberAgreementComponent,
        canActivate: [canActivateGuard],
      },
      {
        path: 'explore',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Legends of Runeterra LoR news, and the decks that are trending.',
          robots: 'index,follow'
        }
      },
      {
        path: 'explore/:server',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Legends of Runeterra LoR news, and the decks that are trending.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'compose/status',
        loadComponent: loadHomeAppsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Home',
          description: 'The best app for Runeterra, find everything you are looking for, decks, meta, leaderboard, statistics, creators, game history and much more!.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'welcome',
        loadComponent: loadHomeComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Runeterra AR - The best app for Runeterra.',
          description: 'The best app for Runeterra, find everything you are looking for, decks, meta, leaderboard, statistics, creators, game history and much more!.',
          robots: 'index,follow'
        }
      },
      {
        path: 'builder',
        loadComponent: loadDeckBuilderLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Builder',
          description: 'Create your own deck of Legends of Runeterra LoR with all the cards, you can search and filter by region, champion, format and much more.',
          robots: 'index,follow'
        }
      },
      {
        path: 'builder/:code',
        loadComponent: loadDeckBuilderLorComponent,
        data: {
          title: 'Builder',
          description: 'Create your own deck of Legends of Runeterra LoR with all the cards, you can search and filter by region, champion, format and much more.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'decks/code/the-path-of-champions',
        loadComponent: loadAdventureDataComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'The Path of Champions',
          description: 'Immerse yourself in the thrilling world of Runeterra with The Path of Champions in Legends of Runeterra (LoR). On our app, we offer detailed insights into the items, relics, and powers available in this mode, allowing you to strategically tailor your champion. Explore a unique gaming experience where each decision plays a pivotal role in shaping your journey through Runeterra.',
          robots: 'index,follow'
        }
      },
      {
        path: 'decks/code/:code',
        loadComponent: loadDeckLorInfoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'index,follow'
        }
      },
      {
        path: 'meta/code/:code',
        loadComponent: loadDeckLorInfoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'qr/:code',
        loadComponent: loadDeckLorInfoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'decks/tournament/code/:code',
        loadComponent: loadDecksTournamentInfoLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'decks/tournament/code',
        loadComponent: loadDecksTournamentInfoLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'stats',
        loadComponent: loadStatsLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Stats',
          description: 'The statistics of all the decks in the meta of Legends of Runeterra LoR, including the best players, the best matches and the worst, Standard and Eternal format.',
          robots: 'index,follow'
        }
      },
      {
        path: 'stats/:server',
        loadComponent: loadStatsLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Stats',
          description: 'The statistics of all the decks in the meta of Legends of Runeterra LoR, including the best players, the best matches and the worst, Standard and Eternal format.',
          robots: 'index,follow'
        }
      },
      {
        path: 'stats/:format/:server',
        loadComponent: loadStatsLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Stats',
          description: 'The statistics of all the decks in the meta of Legends of Runeterra LoR, including the best players, the best matches and the worst, Standard and Eternal format.',
          robots: 'index,follow'
        }
      },
      {
        path: 'decks',
        loadComponent: loadDeckLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'index,follow'
        }
      },
      {
        path: 'decks/:server',
        loadComponent: loadDeckLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'index,follow'
        }
      },
      {
        path: 'leaderboard',
        loadComponent: loadLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Leaderboard',
          description: 'Legends of Runeterra Leaderboard LoR, find top players and recent decks played, filter by americas, europe and apac server.',
          robots: 'index,follow'
        }
      },
      {
        path: 'leaderboard/:server/:country',
        loadComponent: loadLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Leaderboard',
          description: 'Legends of Runeterra Leaderboard  LoR, find top players and recent decks played, filter by americas, europe and apac server.',
          robots: 'index,follow'
        }
      },
      {
        path: 'leaderboard/:server',
        loadComponent: loadLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Leaderboard',
          description: 'Legends of Runeterra Leaderboard LoR, find top players and recent decks played, filter by americas, europe and apac server.',
          robots: 'index,follow'
        }
      },
      {
        path: 'updates',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Legends of Runeterra LoR news, and the decks that are trending.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'news',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Legends of Runeterra LoR news, and the decks that are trending.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'chip',
        loadComponent: loadChipLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Chip game',
          description: 'Chip game',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'spoiler',
        loadComponent: loadSpoilerLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'New Cards',
          description: 'Check out all the cards released in the latest Legends of Runeterra LoR expansion patch.',
          robots: 'index,follow'
        }
      },
      {
        path: 'sets/:name',
        loadComponent: loadSpoilerLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'New Cards',
          description: 'Check out all the cards released in the latest Legends of Runeterra LoR expansion patch.',
          robots: 'index,follow'
        }
      },
      {
        path: 'new-cards',
        loadComponent: loadSpoilerLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'New Cards',
          description: 'Check out all the cards released in the latest Legends of Runeterra LoR expansion patch.',
          robots: 'index,follow'
        }
      },
      {
        path: 'lor/meta',
        loadComponent: loadMetaLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Meta',
          description: 'Find the best LoR meta decks that are being played now, from the best Legends of Runeterra creators, always updated, filter by Standard or Eternal, regions, set and much more.',
          robots: 'index,follow'
        }
      },
      {
        path: 'meta-tier-list',
        loadComponent: loadMetaLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Meta',
          description: 'Find the best LoR meta decks that are being played now, from the best Legends of Runeterra creators, always updated, filter by Standard or Eternal, regions, set and much more.',
          robots: 'index,follow'
        }
      },
      {
        path: 'meta',
        loadComponent: loadMetaLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Meta',
          description: 'Find the best LoR meta decks that are being played now, from the best Legends of Runeterra creators, always updated, filter by Standard or Eternal, regions, set and much more.',
          robots: 'index,follow'
        }
      },
      {
        path: 'meta/:server',
        loadComponent: loadMetaLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Meta',
          description: 'Find the best LoR meta decks that are being played now, from the best Legends of Runeterra creators, always updated, filter by Standard or Eternal, regions, set and much more.',
          robots: 'index,follow'
        }
      },
      {
        path: 'profile/:uid/:tab',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Profile',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
      {
        path: 'profile/:uid',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Profile',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      }, {
        path: 'p/:uid/:tab',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Profile',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
      {
        path: 'p/:uid',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Profile',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
      {
        path: ':uid/status/:id',
        loadComponent: loadDeckProfileComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Status',
          description: 'Status',
          robots: 'index,follow'
        }
      },
      {
        path: ':uid/status/:id/analytics',
        loadComponent: loadDeckProfileComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Status',
          description: 'Status',
          robots: 'noindex,follow'
        }
      },
      {
        path: ':uid/status/:id/comments',
        loadComponent: loadDeckProfileComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Status',
          description: 'Status',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'relics/:code',
        loadComponent: loadAdventureArtifactComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Relics',
          description: 'Show this relic',
          robots: 'index,follow'
        }
      },
      {
        path: 'powers/:code',
        loadComponent: loadAdventureArtifactComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Powers',
          description: 'Show this power',
          robots: 'index,follow'
        }
      },
      {
        path: 'items/:code',
        loadComponent: loadAdventureArtifactComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Items',
          description: 'Show this item',
          robots: 'index,follow'
        }
      },
      {
        path: 'cards/:code',
        loadComponent: loadAdventureArtifactComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Cards',
          description: 'Show this card',
          robots: 'index,follow'
        }
      },
      {
        path: 'cards/:code/:name',
        loadComponent: loadCardsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Cards',
          description: 'Show this card',
          robots: 'index,follow'
        }
      },
      {
        path: 'logout',
        redirectTo: '/settings/connections'
      },
      {
        path: 'settings',
        loadComponent: loadSettingsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Account settings',
          description: 'Account settings',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'settings/:tab',
        loadComponent: loadSettingsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Account settings',
          description: 'Account settings',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'settings/:tab/:option',
        loadComponent: loadSettingsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Account settings',
          description: 'Account settings',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'oauth-callback',
        loadComponent: loadOauthRsoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Account linking RSO',
          description: 'Account linking RSO',
          robots: 'noindex,follow'
        },
      },
      {
        path: 'contact',
        loadComponent: loadContactLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Contact us.',
          description: 'Contact us.',
          robots: 'noindex,follow'
        },
      },
      {
        path: 'notifications',
        loadComponent: loadHomeAppsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Notifications.',
          description: 'Notifications.',
          robots: 'noindex,follow'
        },
      },
      {
        path: 'search',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Legends of Runeterra LoR news, and the decks that are trending.',
          robots: 'index,follow'
        },
      },
      {
        path: 'search-home',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Legends of Runeterra LoR news, and the decks that are trending.',
          robots: 'index,follow'
        },
      },
      {
        path: 'plus',
        loadComponent: loadPlusGetComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'AR+',
          description: 'Get plus now.',
          robots: 'noindex,nofollow'
        }
      },
      {
        path: 'tracker',
        loadComponent: loadTrackerComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Tracker',
          description: 'Tracker',
          robots: 'index,follow'
        }
      },
      {
        path: 'the-path-of-champions',
        loadComponent: loadAdventureDataComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'The Path of Champions',
          description: 'Immerse yourself in the thrilling world of Runeterra with The Path of Champions in Legends of Runeterra (LoR). On our app, we offer detailed insights into the items, relics, and powers available in this mode, allowing you to strategically tailor your champion. Explore a unique gaming experience where each decision plays a pivotal role in shaping your journey through Runeterra.',
          robots: 'index,follow'
        }
      },
      {
        path: 'the-path-of-champions/:server',
        loadComponent: loadAdventureDataComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'The Path of Champions',
          description: 'Immerse yourself in the thrilling world of Runeterra with The Path of Champions in Legends of Runeterra (LoR). On our app, we offer detailed insights into the items, relics, and powers available in this mode, allowing you to strategically tailor your champion. Explore a unique gaming experience where each decision plays a pivotal role in shaping your journey through Runeterra.',
          robots: 'index,follow'
        }
      },
      {
        path: ':aid/overview',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'See your games, statistics and decks.',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
      {
        path: ':aid/likes',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'See your games, statistics and decks.',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
    ]
  },
  {
    path: '',
    loadComponent: loadGeneralIdLayoutComponent,
    children: [
      {
        path: 'login',
        loadComponent: loadLoginComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Login',
          description: 'Login'
        }
      },
      {
        path: 'signup',
        loadComponent: loadSignupComponent,
        canActivate: [canActivateGuard],
      },
      {
        path: 'signup/:option',
        loadComponent: loadSignupComponent,
        canActivate: [canActivateGuard],
      },
      {
        path: 'login/resetpassword',
        loadComponent: loadResetpasswordComponent,
        canActivate: [canActivateGuard],
      },
      {
        path: 'verification',
        loadComponent: loadVerificationComponent,
        canActivate: [canActivateGuard],
      },
      {
        path: 'support',
        loadComponent: loadSupportComponent,
        canActivate: [canActivateGuard],
      }
    ]
  },
  {
    path: '',
    loadComponent: loadGeneralAppComponent,
    children: [
      {
        path: 'login-pc',
        loadComponent: loadTokenAppComponent,
        canActivate: [canActivateGuard],
      },
      {
        path: 'app',
        loadComponent: loadLoginAppComponent,
        canActivate: [canActivateGuard],
      },
      {
        path: 'app/out/success',
        loadComponent: loadLoginAppSuccessComponent,
        canActivate: [canActivateGuard],
      }
    ]
  },
  {
    path: 'app/:plataform',
    loadComponent: loadAppGetUrlComponent,
    canActivate: [canActivateGuard],
    data: {
      title: 'Get app',
      description: 'Get app.',
      robots: 'noindex,follow'
    }
  },
  {
    path: 'discord',
    loadComponent: loadDiscordComponent,
    canActivate: [canActivateGuard],
    data: {
      title: 'Discord',
      description: 'Official Runeterra AR Discord.',
      robots: 'noindex,follow'
    }
  },
  {
    path: 'decks/bot/:code',
    loadComponent: loadDeckBotComponent,
    canActivate: [canActivateGuard],
    data: {
      title: 'Decks',
      description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
      robots: 'noindex,follow'
    }
  },
  {
		path: 'chrono/decks/bot/:code',
		loadComponent: loadDeckBotComponent,
		canActivate: [canActivateGuard],
		data: {
		  title: 'Decks',
		  description: 'The best Chrono decks, from the best creators of Chrono, filter by card, region, set or champion.',
		  robots: 'noindex,follow'
		}
  },
  {
    path: 'decks/bot/worlds/:code',
    loadComponent: loadWorldsDecksComponent,
    canActivate: [canActivateGuard],
    data: {
      title: 'Decks',
      description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
      robots: 'noindex,follow'
    }
  },
  {
    path: 'tft',
    loadComponent: loadGeneralSidenavComponent,
    children: [
      {
        path: 'home',
        loadComponent: loadHomeAppsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Runeterra AR - The best app for Teamfight Tactics (TFT).',
          description: 'The best app for Teamfight Tactics (TFT) find everything you are looking for, comps, meta, leaderboard, statistics, creators, game history and much more!.',
          robots: 'index,follow'
        }
      },
      {
        path: 'builder',
        loadComponent: loadCompsBuilderTftComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Builder',
          description: 'Create your own comp of Teamfight Tactics TFT.',
          robots: 'index,follow'
        }
      },
      {
        path: 'new-set',
        loadComponent: loadNewSetComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'New Set',
          description: 'Check out the newly released TFT Set. New augments, traits, champions & mechanics! Be one step ahead of everyone with our rundown of latest Set!',
          robots: 'index,follow'
        }
      },
      {
        path: 'builder/:code',
        loadComponent: loadCompsBuilderTftComponent,
        data: {
          title: 'Builder',
          description: 'Create your own comp of Teamfight Tactics TFT.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'comps',
        loadComponent: loadCompTftComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Comps',
          description: 'The best TFT comps, from the best creators of Teamfight Tactics.',
          robots: 'index,follow'
        }
      },
      {
        path: 'comps/:server',
        loadComponent: loadCompTftComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Comps',
          description: 'The best TFT comps, from the best creators of Teamfight Tactics.',
          robots: 'index,follow'
        }
      },
      {
        path: 'leaderboard',
        loadComponent: loadTftComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Leaderboard',
          description: 'Teamfight Tactics Leaderboard TFT, find top players and recent decks played.',
          robots: 'index,follow'
        }
      },
      {
        path: 'leaderboard/:server/:country',
        loadComponent: loadTftComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Leaderboard',
          description: 'Teamfight Tactics Leaderboard TFT, find top players and recent decks played.',
          robots: 'index,follow'
        }
      },
      {
        path: 'leaderboard/:server',
        loadComponent: loadTftComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Leaderboard',
          description: 'Teamfight Tactics Leaderboard TFT, find top players and recent decks played.',
          robots: 'index,follow'
        }
      },
      {
        path: 'meta',
        loadComponent: loadMetaTftComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Meta',
          description: 'Discover the best TFT meta team comps that are being played now for Set 15 Teamfight Tactics.',
          robots: 'index,follow'
        }
      },
      {
        path: 'meta/team-comps',
        loadComponent: loadMetaTftComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Meta',
          description: 'Discover the best TFT meta team comps that are being played now for Set 15 Teamfight Tactics.',
          robots: 'index,follow'
        }
      },
      {
        path: 'meta/:server',
        loadComponent: loadMetaTftComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Meta',
          description: 'TFT Meta Tier List Team Comps. Discover the best TFT meta comps that are being played now for Set 15, always updated.',
          robots: 'index,follow'
        }
      },
      {
        path: 'meta/team-comps/:server',
        loadComponent: loadMetaTftComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Meta',
          description: 'TFT Meta Tier List Team Comps. Discover the best TFT meta comps that are being played now for Set 15, always updated.',
          robots: 'index,follow'
        }
      },
      {
        path: 'explore',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Teamfight Tactics TFT news, and the comps that are trending.',
          robots: 'index,follow'
        }
      },
      {
        path: 'comps/code/:code',
        loadComponent: loadCompTftInfoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Comps',
          description: 'The best TFT comps, from the best creators of Teamfight Tactics.',
          robots: 'index,follow'
        }
      },
      {
        path: 'comps/code/:code/:extra',
        loadComponent: loadCompTftInfoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Comps',
          description: 'The best TFT comps, from the best creators of Teamfight Tactics.',
          robots: 'index,follow'
        }
      },
      {
        path: 'meta/code/:code',
        loadComponent: loadCompTftInfoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Comps',
          description: 'The best TFT comps, from the best creators of Teamfight Tactics.',
          robots: 'index,follow'
        }
      },
      {
        path: ':aid',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'See your games, statistics and decks.',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
      {
        path: ':aid/:tab',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'See your games, statistics and decks.',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
      {
        path: ':aid/:tab/:subid',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'See your games, statistics and decks.',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
    ]
  },
  {
    path: 'lor',
    loadComponent: loadGeneralSidenavComponent,
    children: [
      {
        path: 'home',
        loadComponent: loadHomeAppsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Runeterra AR - The best app for Legends of Runeterra (LoR).',
          description: 'The best app for Legends of Runeterra (LoR), find everything you are looking for, decks, meta, leaderboard, statistics, creators, game history and much more!.',
          robots: 'index,follow'
        }
      },
      {
        path: 'home/:server',
        loadComponent: loadHomeAppsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Runeterra AR - The best app for Legends of Runeterra (LoR).',
          description: 'The best app for Legends of Runeterra (LoR), find everything you are looking for, decks, meta, leaderboard, statistics, creators, game history and much more!.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'explore',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Legends of Runeterra LoR news, and the decks that are trending.',
          robots: 'index,follow'
        }
      },
      {
        path: 'explore/:server',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Legends of Runeterra LoR news, and the decks that are trending.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'compose/status',
        loadComponent: loadHomeAppsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Home',
          description: 'Runeterra AR - The best app for Legends of Runeterra (LoR).',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'builder',
        loadComponent: loadDeckBuilderLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Builder',
          description: 'Create your own deck of Legends of Runeterra LoR with all the cards, you can search and filter by region, champion, format and much more.',
          robots: 'index,follow'
        }
      },
      {
        path: 'builder/:code',
        loadComponent: loadDeckBuilderLorComponent,
        data: {
          title: 'Builder',
          description: 'Create your own deck of Legends of Runeterra LoR with all the cards, you can search and filter by region, champion, format and much more.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'decks/code/the-path-of-champions',
        loadComponent: loadAdventureDataComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'The Path of Champions',
          description: 'Immerse yourself in the thrilling world of Runeterra with The Path of Champions in Legends of Runeterra (LoR). On our app, we offer detailed insights into the items, relics, and powers available in this mode, allowing you to strategically tailor your champion. Explore a unique gaming experience where each decision plays a pivotal role in shaping your journey through Runeterra.',
          robots: 'index,follow'
        }
      },
      {
        path: 'decks/code/:code',
        loadComponent: loadDeckLorInfoComponent,
        canActivate: [canActivateGuard], 
        data: {
          title: 'Decks',
          description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'index,follow'
        }
      },
      {
        path: 'decks/code/:code/:option',
        loadComponent: loadDeckLorInfoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'index,follow'
        }
      },
      {
        path: 'meta/code/:code',
        loadComponent: loadDeckLorInfoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'qr/:code',
        loadComponent: loadDeckLorInfoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'decks/tournament/code/:code',
        loadComponent: loadDecksTournamentInfoLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'decks/tournament/code',
        loadComponent: loadDecksTournamentInfoLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'stats',
        loadComponent: loadStatsLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Stats',
          description: 'The statistics of all the decks in the meta of Legends of Runeterra LoR, including the best players, the best matches and the worst, Standard and Eternal format.',
          robots: 'index,follow'
        }
      },
      {
        path: 'stats/:server',
        loadComponent: loadStatsLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Stats',
          description: 'The statistics of all the decks in the meta of Legends of Runeterra LoR, including the best players, the best matches and the worst, Standard and Eternal format.',
          robots: 'index,follow'
        }
      },
      {
        path: 'decks',
        loadComponent: loadDeckLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'index,follow'
        }
      },
      {
        path: 'decks/:server',
        loadComponent: loadDeckLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best LoR deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'index,follow'
        }
      },
      {
        path: 'leaderboard',
        loadComponent: loadLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Leaderboard',
          description: 'Legends of Runeterra Leaderboard LoR, find top players and recent decks played, filter by americas, europe and apac server.',
          robots: 'index,follow'
        }
      },
      {
        path: 'leaderboard/:server/:country',
        loadComponent: loadLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Leaderboard',
          description: 'Legends of Runeterra Leaderboard  LoR, find top players and recent decks played, filter by americas, europe and apac server.',
          robots: 'index,follow'
        }
      },
      {
        path: 'leaderboard/:server',
        loadComponent: loadLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Leaderboard',
          description: 'Legends of Runeterra Leaderboard LoR, find top players and recent decks played, filter by americas, europe and apac server.',
          robots: 'index,follow'
        }
      },
      {
        path: 'updates',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Legends of Runeterra LoR news, and the decks that are trending.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'news',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Legends of Runeterra LoR news, and the decks that are trending.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'chip',
        loadComponent: loadChipLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Chip game',
          description: 'Chip game',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'spoiler',
        loadComponent: loadSpoilerLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'New Cards',
          description: 'Check out all the cards released in the latest Legends of Runeterra LoR expansion patch.',
          robots: 'index,follow'
        }
      },
      {
        path: 'sets/:name',
        loadComponent: loadSpoilerLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'New Cards',
          description: 'Check out all the cards released in the latest Legends of Runeterra LoR expansion patch.',
          robots: 'index,follow'
        }
      },
      {
        path: 'new-cards',
        loadComponent: loadSpoilerLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'New Cards',
          description: 'Check out all the cards released in the latest Legends of Runeterra LoR expansion patch.',
          robots: 'index,follow'
        }
      },
      {
        path: 'meta',
        loadComponent: loadMetaLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Meta',
          description: 'Find the best LoR meta decks that are being played now, from the best Legends of Runeterra creators, always updated, filter by Standard or Eternal, regions, set and much more.',
          robots: 'index,follow'
        }
      },
      {
        path: 'meta/:server',
        loadComponent: loadMetaLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Meta',
          description: 'Find the best LoR meta decks that are being played now, from the best Legends of Runeterra creators, always updated, filter by Standard or Eternal, regions, set and much more.',
          robots: 'index,follow'
        }
      },
      {
        path: 'meta/:format/:server',
        loadComponent: loadMetaLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Meta',
          description: 'Find the best LoR meta decks that are being played now, from the best Legends of Runeterra creators, always updated, filter by Standard or Eternal, regions, set and much more.',
          robots: 'index,follow'
        }
      },
      {
        path: 'profile/:uid/:tab',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Profile',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
      {
        path: 'profile/:uid',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Profile',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      }, {
        path: 'p/:uid/:tab',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Profile',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
      {
        path: 'p/:uid',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Profile',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
      {
        path: ':uid/status/:id',
        loadComponent: loadDeckProfileComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Status',
          description: 'Status',
          robots: 'index,follow'
        }
      },
      {
        path: ':uid/match/:id',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Match',
          description: 'Match',
          robots: 'noindex,follow'
        }
      },
      {
        path: ':uid/status/:id/analytics',
        canActivate: [canActivateGuard],
        loadComponent: loadDeckProfileComponent,
        data: {
          title: 'Status',
          description: 'Status',
          robots: 'noindex,follow'
        }
      },
      {
        path: ':uid/status/:id/comments',
        canActivate: [canActivateGuard],
        loadComponent: loadDeckProfileComponent,
        data: {
          title: 'Status',
          description: 'Status',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'cards/:code',
        loadComponent: loadCardsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Cards',
          description: 'Show this card',
          robots: 'index,follow'
        }
      },
      {
        path: 'relics/:code',
        canActivate: [canActivateGuard],
        loadComponent: loadAdventureArtifactComponent,
        data: {
          title: 'Relics',
          description: 'Show this relic',
          robots: 'index,follow'
        }
      },
      {
        path: 'powers/:code',
        canActivate: [canActivateGuard],
        loadComponent: loadAdventureArtifactComponent,
        data: {
          title: 'Powers',
          description: 'Show this power',
          robots: 'index,follow'
        }
      },
      {
        path: 'items/:code',
        canActivate: [canActivateGuard],
        loadComponent: loadAdventureArtifactComponent,
        data: {
          title: 'Items',
          description: 'Show this item',
          robots: 'index,follow'
        }
      },
      {
        path: 'cards/:code/:name',
        canActivate: [canActivateGuard],
        loadComponent: loadCardsComponent,
        data: {
          title: 'Cards',
          description: 'Show this card',
          robots: 'index,follow'
        }
      },
      {
        path: 'settings',
        loadComponent: loadSettingsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Account settings',
          description: 'Account settings',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'search',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Legends of Runeterra LoR news, and the decks that are trending.',
          robots: 'index,follow'
        },
      },
      {
        path: 'search-home',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Legends of Runeterra LoR news, and the decks that are trending.',
          robots: 'index,follow'
        },
      },
      {
        path: 'tracker',
        loadComponent: loadTrackerComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Tracker',
          description: 'Tracker',
          robots: 'index,follow'
        }
      },
      {
        path: 'the-path-of-champions',
        loadComponent: loadAdventureDataComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'The Path of Champions',
          description: 'Immerse yourself in the thrilling world of Runeterra with The Path of Champions in Legends of Runeterra (LoR). On our app, we offer detailed insights into the items, relics, and powers available in this mode, allowing you to strategically tailor your champion. Explore a unique gaming experience where each decision plays a pivotal role in shaping your journey through Runeterra.',
          robots: 'index,follow'
        }
      },
      {
        path: 'poc',
        loadComponent: loadAdventureDataComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'The Path of Champions',
          description: 'Immerse yourself in the thrilling world of Runeterra with The Path of Champions in Legends of Runeterra (LoR). On our app, we offer detailed insights into the items, relics, and powers available in this mode, allowing you to strategically tailor your champion. Explore a unique gaming experience where each decision plays a pivotal role in shaping your journey through Runeterra.',
          robots: 'index,follow'
        }
      },
      {
        path: 'the-path-of-champions/:server',
        loadComponent: loadAdventureDataComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'The Path of Champions',
          description: 'Immerse yourself in the thrilling world of Runeterra with The Path of Champions in Legends of Runeterra (LoR). On our app, we offer detailed insights into the items, relics, and powers available in this mode, allowing you to strategically tailor your champion. Explore a unique gaming experience where each decision plays a pivotal role in shaping your journey through Runeterra.',
          robots: 'index,follow'
        }
      },
      {
        path: 'poc/:server',
        loadComponent: loadAdventureDataComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'The Path of Champions',
          description: 'Immerse yourself in the thrilling world of Runeterra with The Path of Champions in Legends of Runeterra (LoR). On our app, we offer detailed insights into the items, relics, and powers available in this mode, allowing you to strategically tailor your champion. Explore a unique gaming experience where each decision plays a pivotal role in shaping your journey through Runeterra.',
          robots: 'index,follow'
        }
      },
      {
        path: ':aid',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'See your games, statistics and decks.',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
      {
        path: ':aid/:tab',
        canActivate: [canActivateGuard],
        loadComponent: loadProfileLorComponent,
        data: {
          title: 'See your games, statistics and decks.',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
    ]
  },
  {
    path: '2xko',
    loadComponent: loadGeneralSidenavComponent,
    children: [
      {
        path: 'home',
        loadComponent: loadHomeAppsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Runeterra AR - The best app for 2XKO.',
          description: 'The best app for 2XKO find everything you are looking for, meta, leaderboard, statistics, creators, game history and much more!.',
          robots: 'index,follow'
        }
      },
      {
        path: 'explore',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest 2XKO news.',
          robots: 'index,follow'
        }
      },
      {
        path: 'champions',
        loadComponent: loadChampionsXkoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Champions',
          description: '2XKO Champions.',
          robots: 'index,follow'
        }
      },
      {
        path: 'champions/:value',
        loadComponent: loadChampionsXkoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Champions',
          description: '2XKO Champions.',
          robots: 'index,follow'
        }
      },
      {
        path: ':aid',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'See your games, statistics and decks.',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
      {
        path: ':aid/:tab',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'See your games, statistics and decks.',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
      {
        path: ':aid/:tab/:subid',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'See your games, statistics and decks.',
          description: 'See your games, statistics and decks.',
          robots: 'index,follow'
        }
      },
    ]
  },
 {
    path: 'riftbound',
    loadComponent: loadGeneralSidenavComponent,
    children: [
      {
        path: 'home',
        loadComponent: loadHomeAppsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Runeterra AR - The best app for RIFTBOUND.',
          description: 'The best app for RIFTBOUND, find everything you are looking for, decks, news, creators, game history and much more!.',
          robots: 'index,follow'
        }
      },
      {
        path: 'home/:server',
        loadComponent: loadHomeAppsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Runeterra AR - The best app for RIFTBOUND.',
          description: 'The best app for RIFTBOUND, find everything you are looking for, decks, news, creators, game history and much more!.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'explore',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Legends of Runeterra RIFTBOUND news, and the decks that are trending.',
          robots: 'index,follow'
        }
      },
      {
        path: 'explore/:server',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Legends of Runeterra RIFTBOUND news, and the decks that are trending.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'compose/status',
        loadComponent: loadHomeAppsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Home',
          description: 'Runeterra AR - The best app for RIFTBOUND.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'builder',
        loadComponent: loadDeckBuilderLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Builder',
          description: 'Create your own deck of Legends of Runeterra RIFTBOUND with all the cards, you can search and filter by region, champion, format and much more.',
          robots: 'index,follow'
        }
      },
      {
        path: 'builder/:code',
        loadComponent: loadDeckBuilderLorComponent,
        data: {
          title: 'Builder',
          description: 'Create your own deck of Legends of Runeterra RIFTBOUND with all the cards, you can search and filter by region, champion, format and much more.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'decks/code/:code',
        loadComponent: loadDeckLorInfoComponent,
        canActivate: [canActivateGuard], 
        data: {
          title: 'Decks',
          description: 'The best RIFTBOUND deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'index,follow'
        }
      },
      {
        path: 'decks/code/:code/:option',
        loadComponent: loadDeckLorInfoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best RIFTBOUND deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'index,follow'
        }
      },
      {
        path: 'decks',
        loadComponent: loadDeckLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best RIFTBOUND deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'index,follow'
        }
      },
      {
        path: 'decks/:server',
        loadComponent: loadDeckLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best RIFTBOUND deck, from the best creators of Legends of Runeterra, filter by card, region, set or champion.',
          robots: 'index,follow'
        }
      },
      {
        path: 'new-cards',
        loadComponent: loadSpoilerLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'New Cards',
          description: 'Check out all the cards released in the latest RIFTBOUND expansion patch.',
          robots: 'index,follow'
        }
      },
      {
        path: ':uid/status/:id',
        loadComponent: loadDeckProfileComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Status',
          description: 'Status',
          robots: 'index,follow'
        }
      },
      {
        path: ':uid/status/:id/analytics',
        canActivate: [canActivateGuard],
        loadComponent: loadDeckProfileComponent,
        data: {
          title: 'Status',
          description: 'Status',
          robots: 'noindex,follow'
        }
      },
      {
        path: ':uid/status/:id/comments',
        canActivate: [canActivateGuard],
        loadComponent: loadDeckProfileComponent,
        data: {
          title: 'Status',
          description: 'Status',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'cards/:code',
        loadComponent: loadCardsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Cards',
          description: 'Show this card',
          robots: 'index,follow'
        }
      },
      {
        path: 'cards/:code/:name',
        canActivate: [canActivateGuard],
        loadComponent: loadCardsComponent,
        data: {
          title: 'Cards',
          description: 'Show this card',
          robots: 'index,follow'
        }
      },
      {
        path: 'settings',
        loadComponent: loadSettingsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Account settings',
          description: 'Account settings',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'search',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Legends of Runeterra RIFTBOUND news, and the decks that are trending.',
          robots: 'index,follow'
        },
      },
      {
        path: ':aid',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'See your decks.',
          description: 'See your decks.',
          robots: 'index,follow'
        }
      },
      {
        path: ':aid/:tab',
        canActivate: [canActivateGuard],
        loadComponent: loadProfileLorComponent,
        data: {
          title: 'See your decks.',
          description: 'See your decks.',
          robots: 'index,follow'
        }
      },
    ]
  },
 {
    path: 'chrono',
    loadComponent: loadGeneralSidenavComponent,
    children: [
      {
        path: 'home',
        loadComponent: loadHomeAppsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Runeterra AR - The best app for CHRONO.',
          description: 'The best app for CHRONO, find everything you are looking for, decks, news, creators, game history and much more!.',
          robots: 'index,follow'
        }
      },
      {
        path: 'home/:server',
        loadComponent: loadHomeAppsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Runeterra AR - The best app for CHRONO.',
          description: 'The best app for CHRONO, find everything you are looking for, decks, news, creators, game history and much more!.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'explore',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Chrono news, and the decks that are trending.',
          robots: 'index,follow'
        }
      },
      {
        path: 'explore/:server',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Chrono news, and the decks that are trending.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'compose/status',
        loadComponent: loadHomeAppsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Home',
          description: 'Runeterra AR - The best app for Chro.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'builder',
        loadComponent: loadDeckBuilderLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Builder',
          description: 'Create your own deck of Chrono with all the cards, you can search and filter by syndicate, agents, format and much more.',
          robots: 'index,follow'
        }
      },
      {
        path: 'builder/:code',
        loadComponent: loadDeckBuilderLorComponent,
        data: {
          title: 'Builder',
          description: 'Create your own deck of Chrono with all the cards, you can search and filter by syndicate, agents, format and much more.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'decks/code/:code',
        loadComponent: loadDeckLorInfoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best CHRONO deck, from the best creators of Chrono, filter by card, region, set or champion.',
          robots: 'index,follow'
        }
      },
      {
        path: 'decks/code/:code/:option',
        loadComponent: loadDeckLorInfoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best CHRONO deck, from the best creators of Chrono, filter by card, region, set or champion.',
          robots: 'index,follow'
        }
      },
	  {
        path: 'decks/tournament/code/:code',
        loadComponent: loadDecksTournamentInfoLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best Chrono decks, from the best creators of Chrono, filter by card, region, set or champion.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'decks/tournament/code',
        loadComponent: loadDecksTournamentInfoLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best Chrono decks, from the best creators of Chrono, filter by card, region, set or champion.',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'decks',
        loadComponent: loadDeckLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best CHRONO deck, from the best creators of Chrono, filter by card, region, set or champion.',
          robots: 'index,follow'
        }
      },
      {
        path: 'decks/:server',
        loadComponent: loadDeckLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Decks',
          description: 'The best CHRONO deck, from the best creators of Chrono, filter by card, region, set or champion.',
          robots: 'index,follow'
        }
      },
      {
        path: 'new-cards',
        loadComponent: loadSpoilerLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'New Cards',
          description: 'Check out all the cards released in the latest Chrono expansion patch.',
          robots: 'index,follow'
        }
      },
      {
        path: 'leaderboard',
        loadComponent: loadChronoComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Leaderboard',
          description: 'Chrono leaderboard, find top ranked Constructed players.',
          robots: 'index,follow'
        }
      },
      {
        path: ':uid/status/:id',
        loadComponent: loadDeckProfileComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Status',
          description: 'Status',
          robots: 'index,follow'
        }
      },
      {
        path: ':uid/status/:id/analytics',
        canActivate: [canActivateGuard],
        loadComponent: loadDeckProfileComponent,
        data: {
          title: 'Status',
          description: 'Status',
          robots: 'noindex,follow'
        }
      },
      {
        path: ':uid/status/:id/comments',
        canActivate: [canActivateGuard],
        loadComponent: loadDeckProfileComponent,
        data: {
          title: 'Status',
          description: 'Status',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'cards/:code',
        loadComponent: loadCardsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Cards',
          description: 'Show this card',
          robots: 'index,follow'
        }
      },
      {
        path: 'cards/:code/:name',
        canActivate: [canActivateGuard],
        loadComponent: loadCardsComponent,
        data: {
          title: 'Cards',
          description: 'Show this card',
          robots: 'index,follow'
        }
      },
      {
        path: 'settings',
        loadComponent: loadSettingsComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Account settings',
          description: 'Account settings',
          robots: 'noindex,follow'
        }
      },
      {
        path: 'search',
        loadComponent: loadTrendingComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'Explore',
          description: 'The latest Chrono news, and the decks that are trending.',
          robots: 'index,follow'
        },
      },
      {
        path: ':aid',
        loadComponent: loadProfileLorComponent,
        canActivate: [canActivateGuard],
        data: {
          title: 'See your decks.',
          description: 'See your decks.',
          robots: 'index,follow'
        }
      },
      {
        path: ':aid/:tab',
        canActivate: [canActivateGuard],
        loadComponent: loadProfileLorComponent,
        data: {
          title: 'See your decks.',
          description: 'See your decks.',
          robots: 'index,follow'
        }
      },
    ]
  },
  {
    path: 'landing',
    loadComponent: loadGeneralSidenavComponent
  },
  {
    path: '',
    loadComponent: loadGeneralSidenavComponent,
    children: [
      {
        path: '**',
        loadComponent: loadHomeComponent,
        data: {
          title: 'Welcome',
          description: 'The best app for Legends of Runeterra, find everything you are looking for, decks, meta, leaderboard, statistics, creators, game history and much more!.',
          robots: 'index,follow'
        }
      }
    ]
  }



];



@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: false, onSameUrlNavigation: "ignore"
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(private dialogo: MatDialog) {

  }

  AuthGuard(route: Route): boolean {

    return this.dialogo.openDialogs.length == 0;

  }

   
}
